
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ProjectsProvider } from './contexts/ProjectContext';
import { ExpenseProvider } from './contexts/ExpenseContext';
import { UserProvider } from './contexts/UserContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { ReminderProvider } from './contexts/ReminderContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <UserProvider>
          <CompanyProvider>
            <ProjectsProvider>
              <ExpenseProvider>
                <NotificationProvider>
                  <ReminderProvider>
                    <App />
                  </ReminderProvider>
                </NotificationProvider>
              </ExpenseProvider>
            </ProjectsProvider>
          </CompanyProvider>
        </UserProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);